<template>
  <custom-dialog :title="`Clone ${row.name}`">
    <template
      ><h2>
        Are you sure you want to clone
        <ul>
          <li v-for="(item, index) in row.item" :key="index">
            {{ item.name }},
          </li>
        </ul>
      </h2></template
    >
    <template #footer-btn>
      <el-button class="btn btn-form btn-pink btn-footer" @click="submit()"
        >Clone</el-button
      >
    </template>
  </custom-dialog>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import CustomDialog from "@/components/base/customDialog";
export default {
  props: {
    row: Object,
  },
  components: {
    CustomDialog,
  },
  methods: {
    async submit() {
      const creative_ids = this.row.item.map((res) => res._id);
      await store.dispatch("creative/cloneCreativesByIds", {
        creative_ids,
      });
      this.$message({ message: "Success!", type: "success" });
      store.commit("setDialogVisible", false);
    },
  },
};
</script>

<style lang="sass" scoped>
ul
  padding: 16px
  font-size: 16px
</style>
